import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../helpers/export'
import SectorPerformanceService from './SectorPerformanceService'

export const getFdiDomestic = createAsyncThunk(
  'industryAnalysis/getFdiDomestic',
  async (params, { rejectWithValue }) => {
    try {
      const res = await SectorPerformanceService.getFdiDomestic(params)
      if (res.success) {
        return { ...res.data, ...params }
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getLargeSme = createAsyncThunk(
  'industryAnalysis/getLargeSme',
  async (params, { rejectWithValue }) => {
    try {
      const res = await SectorPerformanceService.getLargeSme(params)
      if (res.success) {
        return { ...res.data, ...params }
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getListedLarge = createAsyncThunk(
  'industryAnalysis/getListedLarge',
  async (params, { rejectWithValue }) => {
    try {
      const res = await SectorPerformanceService.getListedLarge(params)
      if (res.success) {
        return { ...res.data, ...params }
      }
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const sectorDefaultVsicIdPerformanceAnalyzerExport = createAsyncThunk(
  'industryAnalysis/sectorDefaultVsicIdPerformanceAnalyzerExport',
  async (params, { rejectWithValue }) => {
    try {
      const res =
        await SectorPerformanceService.sectorDefaultVsicIdPerformanceAnalyzerExport(
          params,
        )
      handleExport(res.data, res.filename)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const sectorDefaultVsicIdPerformanceAnalyzerCompareExport =
  createAsyncThunk(
    'industryAnalysis/sectorDefaultVsicIdPerformanceAnalyzerCompareExport',
    async (params, { rejectWithValue }) => {
      try {
        const res =
          await SectorPerformanceService.sectorDefaultVsicIdPerformanceAnalyzerCompareExport(
            params,
          )
        handleExport(res.data, res.filename)
      } catch (error) {
        return rejectWithValue(error)
      }
    },
  )
